// src/admin/layout/Sidebar.jsx
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./Sidebar.css";

function Sidebar() {
  const [openPrograms, setOpenPrograms] = useState(false);
  const [openHealth, setOpenHealth] = useState(false);
  const [openEnvironment, setOpenEnvironment] = useState(false);
  const [openReports, setOpenReports] = useState(false);
  const [openGallery, setOpenGallery] = useState(false);
  const [openTestimonials, setOpenTestimonials] = useState(false);

  return (
    <div className="sidebar">
      <h2 className="sidebar-logo">SRV NGO</h2>

      {/* Dashboard */}
      <NavLink
        to="/admin"
        end
        className={({ isActive }) =>
          isActive ? "sidebar-link active" : "sidebar-link"
        }
      >
        Dashboard
      </NavLink>

      {/* Programs */}
      <div className="sidebar-section">
        <div
          className="sidebar-link dropdown-toggle"
          onClick={() => setOpenPrograms(!openPrograms)}
        >
          <span>Programs</span>
          <span className={`arrow ${openPrograms ? "open" : ""}`}>▼</span>
        </div>

        <div className={`dropdown ${openPrograms ? "show" : ""}`}>
          <NavLink
            to="/admin/programs"
            className={({ isActive }) =>
              isActive ? "dropdown-link active" : "dropdown-link"
            }
          >
            Manage Programs
          </NavLink>
        </div>
      </div>

      {/* Health */}
      <div className="sidebar-section">
        <div
          className="sidebar-link dropdown-toggle"
          onClick={() => setOpenHealth(!openHealth)}
        >
          <span>Health</span>
          <span className={`arrow ${openHealth ? "open" : ""}`}>▼</span>
        </div>

        <div className={`dropdown ${openHealth ? "show" : ""}`}>
          <NavLink
            to="/admin/health"
            className={({ isActive }) =>
              isActive ? "dropdown-link active" : "dropdown-link"
            }
          >
            Manage Health
          </NavLink>
        </div>
      </div>

      {/* Environment */}
      <div className="sidebar-section">
        <div
          className="sidebar-link dropdown-toggle"
          onClick={() => setOpenEnvironment(!openEnvironment)}
        >
          <span>Environment</span>
          <span className={`arrow ${openEnvironment ? "open" : ""}`}>▼</span>
        </div>

        <div className={`dropdown ${openEnvironment ? "show" : ""}`}>
          <NavLink
            to="/admin/environment"
            className={({ isActive }) =>
              isActive ? "dropdown-link active" : "dropdown-link"
            }
          >
            Manage Environment
          </NavLink>
        </div>
      </div>

      {/* Reports */}
      <div className="sidebar-section">
        <div
          className="sidebar-link dropdown-toggle"
          onClick={() => setOpenReports(!openReports)}
        >
          <span>Reports</span>
          <span className={`arrow ${openReports ? "open" : ""}`}>▼</span>
        </div>

        <div className={`dropdown ${openReports ? "show" : ""}`}>
          <NavLink
            to="/admin/reports"
            className={({ isActive }) =>
              isActive ? "dropdown-link active" : "dropdown-link"
            }
          >
            Manage Reports
          </NavLink>
        </div>
      </div>

      {/* Gallery */}
      <div className="sidebar-section">
        <div
          className="sidebar-link dropdown-toggle"
          onClick={() => setOpenGallery(!openGallery)}
        >
          <span>Gallery</span>
          <span className={`arrow ${openGallery ? "open" : ""}`}>▼</span>
        </div>

        <div className={`dropdown ${openGallery ? "show" : ""}`}>
          <NavLink
            to="/admin/gallery"
            className={({ isActive }) =>
              isActive ? "dropdown-link active" : "dropdown-link"
            }
          >
            Manage Gallery
          </NavLink>
        </div>
      </div>

      {/* Testimonials */}
      <div className="sidebar-section">
        <div
          className="sidebar-link dropdown-toggle"
          onClick={() => setOpenTestimonials(!openTestimonials)}
        >
          <span>Testimonials</span>
          <span className={`arrow ${openTestimonials ? "open" : ""}`}>▼</span>
        </div>

        <div className={`dropdown ${openTestimonials ? "show" : ""}`}>
          <NavLink
            to="/admin/testimonials"
            className={({ isActive }) =>
              isActive ? "dropdown-link active" : "dropdown-link"
            }
          >
            Manage Testimonials
          </NavLink>
        </div>
      </div>

      {/* Contact Direct Link */}
      <NavLink
        to="/admin/contact"
        className={({ isActive }) =>
          isActive ? "sidebar-link active" : "sidebar-link"
        }
      >
        Contact
      </NavLink>
    </div>
  );
}

export default Sidebar;